const searchOverlayActive = ref();
const searchInputOnPage = ref();

export default () => {
  return { searchOverlayActive, searchInputOnPage };
};
